import { useState } from 'react';

export default function HomePage() {
  const [activeTab, setActiveTab] = useState('all');

  const benefits = [
    {
      id: 1,
      title: '红包周周送',
      icon: '🏆',
      description: '每周二根据上周活跃度发放红包奖励至战队成员GG账号',
      details: [
        '战队成员自动参加,首次领取需私信客服登记GG账号',
        '本奖励不影响GG官方的Fish Buffet奖励系统',
        '红包奖池每日在粉丝群公布'
      ]
    },
    {
      id: 2,
      title: '新成员首充',
      icon: '💰',
      description: '新加入战队成员首次通过收银台充值500元即可获赠1个月Youtube逍遥Poker会员',
      details: []
    },
    {
      id: 3,
      title: '小虾送软件',
      icon: '🏅',
      description: '战队成员首次达到VIP小虾级别即可获赠任意指定软件1款',
      details: [
        'GTOwizard: 1个月会员 — 价值49刀',
        'Deeppineapple: 3万算力 — 价值300元',
        'Dler VPN: 1年会员 — 价值299元'
      ]
    }
  ];

  const features = [
    {
      text: 'GG扑克(GGPoker)是全球最大的线上扑克平台,同时也是世界顶级赛事WSOP(世界扑克系列赛)的官方拥有者'
    },
    {
      text: '平台自动提供高达60%的玩家返利机制,以及GG Care等额外福利'
    },
    {
      text: '拥有业内领先的软件系统,保障玩家享受安全、稳定、流畅的游戏体验'
    },
    {
      text: '丰富任务 + 高返利 + 福利赛,新手玩家和顶级大神的最佳选择'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-black to-gray-900 text-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-black/80 backdrop-blur-md border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-3xl">🎁</span>
              <h1 className="text-xl font-bold bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent">
                逍遥哥GG战队
              </h1>
            </div>
            <nav className="hidden md:flex items-center gap-8">
              <a href="#about" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">关于GG扑克</a>
              <a href="#join" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">如何加入</a>
              <a href="#benefits" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">战队福利</a>
              <a href="#contact" className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-block mb-6 px-6 py-2 bg-gradient-to-r from-cyan-500/20 to-teal-500/20 border border-cyan-500/30 rounded-full">
            <span className="text-sm font-medium text-cyan-400">3重福利大升级</span>
          </div>
          <h2 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span className="bg-gradient-to-r from-cyan-400 via-teal-400 to-emerald-400 bg-clip-text text-transparent">
              逍遥哥GG战队
            </span>
            <br />
            <span className="text-white text-4xl md:text-5xl mt-4 block">3重福利大升级</span>
          </h2>
          
          {/* Benefits Preview */}
          <div className="max-w-5xl mx-auto mb-12">
            <div className="grid md:grid-cols-3 gap-6">
              {benefits.map((benefit) => (
                <div 
                  key={benefit.id}
                  className="p-6 bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-xl hover:border-cyan-500/50 transition-all duration-300"
                >
                  <div className="text-4xl mb-4">{benefit.icon}</div>
                  <h4 className="text-lg font-bold mb-3 text-white">{benefit.title}</h4>
                  <p className="text-sm text-gray-400 leading-relaxed">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>

          <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto">
            发现最适合您需求的优质软件
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="http://playgg3.fun/xiaoyao" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group h-14 px-8 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-lg font-semibold text-white hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <span className="text-xl">🃏</span>
              <span>立即注册加入战队</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </a>
            <a 
              href="#benefits"
              className="h-14 px-8 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-lg font-semibold text-white hover:shadow-lg hover:shadow-teal-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              战队福利
            </a>
            <a 
              href="https://xypktools.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="h-14 px-8 bg-gray-800 hover:bg-gray-700 rounded-lg font-semibold text-white transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              软件推荐
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 px-6 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-4xl mb-4 block">🎯</span>
            <h3 className="text-3xl md:text-4xl font-bold mb-4">关于 GG扑克</h3>
            <p className="text-gray-400">全球最大的线上扑克平台</p>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="p-6 bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-xl hover:border-cyan-500/50 transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-300 leading-relaxed">{feature.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Section */}
      <section id="join" className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-4xl mb-4 block">🚀</span>
            <h3 className="text-3xl md:text-4xl font-bold mb-4">如何加入「逍遥哥GG战队」</h3>
          </div>
          
          <div className="space-y-8">
            <div className="p-8 bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-xl">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-lg flex items-center justify-center flex-shrink-0 font-bold">
                  1
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-bold mb-3 flex items-center gap-2">
                    <span>👉</span>
                    <span>点击专属链接注册</span>
                  </h4>
                  <p className="text-gray-400 mb-4">
                    点击该注册链接,在完成下载和注册后自动加入
                  </p>
                  <a 
                    href="http://playgg3.fun/xiaoyao" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-lg font-semibold hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <span className="text-lg">🃏</span>
                    <span>点击注册链接</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="p-8 bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-xl">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-lg flex items-center justify-center flex-shrink-0 font-bold">
                  2
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-bold mb-3 flex items-center gap-2">
                    <span>🧾</span>
                    <span>手动注册方式</span>
                  </h4>
                  <ul className="space-y-2 text-gray-400">
                    <li className="flex items-start gap-2">
                      <span className="text-cyan-500 mt-1">•</span>
                      <span>自行下载 GG Poker 软件</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-cyan-500 mt-1">•</span>
                      <span>在注册页面填写推荐人代码: <span className="text-white font-semibold">xiaoyao</span></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="p-6 bg-gradient-to-r from-cyan-500/10 to-teal-500/10 border border-cyan-500/30 rounded-xl text-center">
              <p className="text-lg">
                <span className="text-2xl mr-2">🎁</span>
                成功加入后即可参与以下各类<span className="text-cyan-400 font-semibold">专属福利</span>及粉丝群内<span className="text-cyan-400 font-semibold">每周红包大放送</span>!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" className="py-20 px-6 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-4xl mb-4 block">🧧</span>
            <h3 className="text-3xl md:text-4xl font-bold mb-4">战队专属3重福利</h3>
            <p className="text-gray-400">(长期有效)</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {benefits.map((benefit) => (
              <div 
                key={benefit.id}
                className="group p-8 bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-xl hover:border-cyan-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10"
              >
                <div className="text-5xl mb-6">{benefit.icon}</div>
                <h4 className="text-2xl font-bold mb-4 text-white">{benefit.title}</h4>
                <p className="text-gray-400 mb-6 leading-relaxed">{benefit.description}</p>
                {benefit.details.length > 0 && (
                  <ul className="space-y-3">
                    {benefit.details.map((detail, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-gray-500">
                        <span className="text-cyan-500 mt-1">•</span>
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 p-6 bg-gradient-to-r from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-xl">
            <h4 className="text-xl font-bold mb-4 flex items-center gap-2">
              <span>🧧</span>
              <span>备注</span>
            </h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start gap-2">
                <span className="text-cyan-500 mt-1">•</span>
                <span>活动最终解释权归逍遥哥所有</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-500 mt-1">•</span>
                <a 
                  href="http://playgg3.fun/xiaoyao" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer inline-flex items-center gap-1"
                >
                  <span>📥 点击加入逍遥哥GG战队</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-4xl mb-4 block">📢</span>
            <h3 className="text-3xl md:text-4xl font-bold mb-4">更多信息</h3>
            <p className="text-gray-400">关注我们获取最新资讯</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <a 
              href="https://www.youtube.com/@%E9%80%8D%E9%81%A5Poker" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group p-6 bg-gradient-to-br from-cyan-500/10 to-teal-500/10 border border-cyan-500/30 rounded-xl hover:border-cyan-500 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center text-2xl flex-shrink-0">
                  📺
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-white mb-1">YouTube频道</h4>
                  <p className="text-sm text-gray-400">逍遥Poker频道</p>
                </div>
                <i className="ri-arrow-right-line text-cyan-500 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </a>

            <a 
              href="https://t.me/xiaoyaopokergg" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group p-6 bg-gradient-to-br from-cyan-500/10 to-teal-500/10 border border-cyan-500/30 rounded-xl hover:border-cyan-500 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center text-2xl flex-shrink-0">
                  💬
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-white mb-1">Telegram粉丝群</h4>
                  <p className="text-sm text-gray-400">加入社区讨论</p>
                </div>
                <i className="ri-arrow-right-line text-cyan-500 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </a>

            <a 
              href="https://t.me/xiaoyaoxiaomei" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group p-6 bg-gradient-to-br from-cyan-500/10 to-teal-500/10 border border-cyan-500/30 rounded-xl hover:border-cyan-500 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center text-2xl flex-shrink-0">
                  👩‍💼
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-white mb-1">客服小美</h4>
                  <p className="text-sm text-gray-400">专属客服支持</p>
                </div>
                <i className="ri-arrow-right-line text-cyan-500 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </a>

            <a 
              href="https://xypktools.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group p-6 bg-gradient-to-br from-cyan-500/10 to-teal-500/10 border border-cyan-500/30 rounded-xl hover:border-cyan-500 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center text-2xl flex-shrink-0">
                  🛠️
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-white mb-1">软件推荐</h4>
                  <p className="text-sm text-gray-400">专业工具推荐</p>
                </div>
                <i className="ri-arrow-right-line text-cyan-500 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 bg-black border-t border-gray-800">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <span className="text-3xl">🎁</span>
              <h2 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent">
                逍遥哥GG战队
              </h2>
            </div>
            <p className="text-gray-500 text-sm mb-6">
              © 2025 逍遥哥GG战队. All rights reserved.
            </p>
            <div className="flex items-center justify-center gap-2 text-xs text-gray-600">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-gray-400 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
